import { functionUtils } from 'utils';
import ConfirmCancelFormEditPopup from './popup';

const ConfirmCancelFormEditModal = ({ isShow, action, actionClose }) => {
  const handleOnClick = () => {
    if (functionUtils.isFunction(action)) {
      action();
    }
  };

  const handleOnClose = () => {
    if (functionUtils.isFunction(actionClose)) {
      actionClose();
    }
  };

  return (
    <ConfirmCancelFormEditPopup
      isOpen={isShow}
      onClose={handleOnClose}
      onClick={handleOnClick}
      isBackdropOverlap={true}
      zIndexBackdropOverlap={1070}
      zIndexModal={1071}
    />
  );
};

export default ConfirmCancelFormEditModal;
